import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { LayoutDashboard, CalendarDays, Users, Scissors, UserCog, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ThemeToggle } from "@/components/ThemeToggle";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/admin/agenda", label: "Agenda", icon: CalendarDays, id: "agenda" },
  { to: "/admin/clientes", label: "Clientes", icon: Users, id: "clients" },
  { to: "/admin/servicios", label: "Servicios", icon: Scissors, id: "services" },
  { to: "/admin/empleados", label: "Empleados", icon: UserCog, id: "stylists" },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="grid min-h-screen place-items-center bg-background text-muted-foreground">Cargando...</div>;
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="flex min-h-screen bg-background">
      {/* sidebar */}
      <aside className="fixed bottom-0 left-0 right-0 z-30 flex border-t border-border bg-card lg:static lg:h-screen lg:w-64 lg:flex-col lg:border-r lg:border-t-0">
        <div className="hidden p-6 lg:block">
          <p className="font-serif-display text-2xl font-semibold">Lupita</p>
          <p className="overline text-primary">Panel Admin</p>
        </div>
        <nav className="flex w-full justify-around lg:mt-4 lg:flex-col lg:justify-start lg:gap-1 lg:px-3">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.id}`}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 px-3 py-3 text-xs transition-colors lg:flex-row lg:gap-3 lg:text-sm ${
                  isActive ? "text-primary lg:border-l-2 lg:border-primary lg:bg-primary/5" : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              <n.icon size={18} strokeWidth={1.5} />
              <span>{n.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:mt-auto lg:block lg:p-3">
          <button
            data-testid="admin-logout"
            onClick={() => { logout(); navigate("/login"); }}
            className="flex w-full items-center gap-3 px-3 py-3 text-sm text-muted-foreground transition-colors hover:text-destructive"
          >
            <LogOut size={18} strokeWidth={1.5} /> Cerrar sesión
          </button>
        </div>
      </aside>

      {/* main */}
      <div className="flex-1 pb-20 lg:pb-0">
        <header className="flex items-center justify-between border-b border-border px-6 py-4">
          <p className="text-sm text-muted-foreground">
            Hola, <span className="text-foreground">{user.name}</span>
          </p>
          <div className="flex items-center gap-3">
            <ThemeToggle />
            <button
              onClick={() => { logout(); navigate("/login"); }}
              className="text-muted-foreground transition-colors hover:text-destructive lg:hidden"
            >
              <LogOut size={18} strokeWidth={1.5} />
            </button>
          </div>
        </header>
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
